import "./FretboardLocation.scss";

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";

import AudioKey from "../../lib/AudioKey";
import Pitch from "../utility/Pitch";
import { modeHasMinorQuality, modes, pitchNames } from "../../lib/audioTools";
import metaActions from "../../state/meta/actions";
import store from "../../store";

const ucf = (n) => n.charAt(0).toUpperCase() + n.substr(1);

class FretboardLocation extends PureComponent {
	static propTypes = {
		dotted: PropTypes.bool,
		fret: PropTypes.number,
		highlight: PropTypes.number,
		instrument: PropTypes.string,
		number: PropTypes.number,
		pitch: PropTypes.number,
		relativeKey: PropTypes.instanceOf(AudioKey),
		selectedKey: PropTypes.instanceOf(AudioKey),
		sideDots: PropTypes.number,
		string: PropTypes.number
	};

	onMouseOver = debounce(() => {
		let { pitch } = this.props;
		store.dispatch(metaActions.update({ highlight: pitch }));
	}, 200, { leading: true, trailing: false })

	render() {
		let {
			dotted,
			fret,
			highlight,
			instrument,
			number,
			pitch,
			relativeKey,
			selectedKey,
			sideDots,
			string
		} = this.props;

		let classNames = [
			"loc",
			`loc--string-${1 + string}`,
			`loc--${instrument}-string-${1 + string}`,
			`loc--fret-${fret}`,
			`loc-${1 + string}-${fret}`
		];

		if (dotted) {
			classNames.push("loc-dotted");
		}

		let sideDotEl = sideDots ? (
			<div className={`sidedots sidedots--${sideDots}`} />
		) : null;

		if (selectedKey && selectedKey.pitches.indexOf(pitch) < 0) {
			return (
				<td className={[...classNames, "gone"].join(" ")}>
					{ sideDotEl }
				</td>
			);
		}

		if (pitch === highlight) {
			classNames.push("highlighted");
		}

		let pitchName = pitchNames[pitch][0];
		let opacity = (1 + (2 - number) * 0.2); // TODO: Use pitch in this generator
		let tonicDescriptor = undefined;

		if (selectedKey) {
			pitchName = selectedKey.getPitchName(pitch);
			if (relativeKey) {
				if (pitch === selectedKey.pitch) {
					classNames.push(`${modes[selectedKey.mode]}-tonic`);
					tonicDescriptor = `${ucf(modes[selectedKey.mode])} tonic`;
				}

				if (pitch === relativeKey.pitch) {
					classNames.push(`${modes[relativeKey.mode]}-tonic`);
					tonicDescriptor = `${ucf(modes[relativeKey.mode])} tonic`;
				}
			}

			else {
				// Not a major or minor key
				if (pitch === selectedKey.pitch) {
					let hasMinorQuality = modeHasMinorQuality(selectedKey.mode);
					classNames.push(`${hasMinorQuality ? "minor" : "major"}-tonic`);
					tonicDescriptor = `${hasMinorQuality ? "Minor" : "Major"} tonic`;
				}
			}
		}

		return (
			<td
				className={classNames.join(" ")}
				title={tonicDescriptor}
				onMouseOver={this.onMouseOver}>
				<div className="bg" style={{ opacity }} />
				<div className="p0">
					<span className="p1">
						<span className="p2" style={{ opacity }}>
							<Pitch name={pitchName} />
							<sub>{ number }</sub>
						</span>
					</span>
				</div>
				{ sideDotEl }
			</td>
		);
	}
}

export default FretboardLocation;
